/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyRufiyaa = createReactComponent("outline", "currency-rufiyaa", "IconCurrencyRufiyaa", [["path", { "d": "M20 16h.01", "key": "svg-0" }], ["path", { "d": "M4 16c9.5 -4 11.5 -8 14 -9", "key": "svg-1" }], ["path", { "d": "M12 8l5 3", "key": "svg-2" }]]);

export { IconCurrencyRufiyaa as default };
//# sourceMappingURL=IconCurrencyRufiyaa.mjs.map
